import {Outlet,Navigate} from 'react-router-dom'

export default function ProtectedRoute({isAuthorized}) {
    return isAuthorized ? <Outlet /> : <Navigate to="/" />;
}
